module.exports = __webpack_public_path__ + "static/media/6-iron.4c28a6dd.png";